import dayjs from 'dayjs';
import mixins from 'vue-typed-mixins';

import { 変換枚数Api, 変換枚数Response } from '@/openapi/user';

import 企業ユーザーMixin from '@/entries/user/mixins/企業ユーザーMixin';

import { DAYJS_YM_NUMBER_FORMAT } from '@/classes/common/Constants';
import UserApiUtility from '@/classes/common/UserApiUtility';

export default mixins(企業ユーザーMixin).extend({
  name: 'M変換枚数Mixin',

  data(): {
    currentYM: number;
    変換枚数詳細: 変換枚数Response | null;
  } {
    return {
      currentYM: Number(dayjs().format(DAYJS_YM_NUMBER_FORMAT)),
      変換枚数詳細: null,
    };
  },

  computed: {
    max取込枚数(): number {
      return this.me.cライセンス数 * 500;
    },
    変換枚数(): number {
      return this.変換枚数詳細 !== null ? this.変換枚数詳細.c枚数 : 0;
    },
  },

  created(): void {
    this.load変換枚数();
  },

  methods: {
    async load変換枚数(): Promise<void> {
      const response = await UserApiUtility.ogApi(変換枚数Api).show変換枚数(this.currentYM);
      this.変換枚数詳細 = response.data;
    },
  },
});
